import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/common/app';
export default class FileListState {
  constructor(sharedFiles) {
    if (sharedFiles === void 0) {
      sharedFiles = false;
    }
    _defineProperty(this, "user", void 0);
    _defineProperty(this, "files", void 0);
    _defineProperty(this, "moreResults", void 0);
    _defineProperty(this, "loading", void 0);
    _defineProperty(this, "sharedFiles", void 0);
    this.user = null;
    this.files = [];
    this.moreResults = false;
    this.loading = false;
    this.sharedFiles = sharedFiles;
  }

  /**
   * Set the user and load their file list.
   * @param user The user whose files to load.
   */
  setUser(user) {
    if (user === this.user) return;
    this.user = user;
    this.files = [];
    this.loadResults();
  }
  refresh() {
    this.files = [];
    this.loadResults();
    m.redraw();
  }

  /**
   * Load more files for the current user, starting from the given offset.
   * @param offset The starting index for loading more files.
   * @returns A promise resolving to the loaded files.
   */
  async loadResults(offset) {
    if (offset === void 0) {
      offset = 0;
    }
    if (!this.sharedFiles && !this.user) return Promise.reject('User not set');
    this.loading = true;
    if (this.sharedFiles && this.files.length > 0 && offset === 0) {
      this.loading = false;
      return Promise.resolve(this.files);
    }
    let route = 'fof/uploads';
    let params = {};
    if (!this.sharedFiles && this.user) {
      params = {
        filter: {
          user: this.user.id()
        },
        page: {
          offset
        }
      };
    } else {
      route = 'fof/upload/shared-files';
      params = {
        page: {
          offset
        }
      };
    }
    const results = await app.store.find(route, params);
    return this.parseResults(results);
  }

  /**
   * Load the next set of results.
   */
  async loadMore() {
    this.loading = true;
    return this.loadResults(this.files.length);
  }
  parseResults(results) {
    var _payload;
    this.files = this.files.concat(results);
    this.loading = false;
    this.moreResults = !!(results != null && (_payload = results.payload) != null && (_payload = _payload.links) != null && _payload.next);
    m.redraw();
    return results;
  }

  /**
   * Add files to the beginning of the list.
   * @param files The files to be added.
   */
  addToList(files) {
    if (Array.isArray(files)) {
      this.files.unshift(...files);
    } else {
      this.files.unshift(files);
    }
    m.redraw();
  }

  /**
   * Remove files from the list.
   * @param files The files to be removed.
   */
  removeFromList(files) {
    if (Array.isArray(files)) {
      this.files = this.files.filter(file => !files.includes(file));
    } else {
      this.files = this.files.filter(file => file !== files);
    }
    m.redraw();
  }

  /**
   * Check if there are files in the list.
   * @returns True if there are files, false otherwise.
   */
  hasFiles() {
    return this.files.length > 0;
  }

  /**
   * Check if the file list is currently loading.
   * @returns True if loading, false otherwise.
   */
  isLoading() {
    return this.loading;
  }

  /**
   * Check if there are more files to load.
   * @returns True if there are more files, false otherwise.
   */
  hasMoreResults() {
    return this.moreResults;
  }

  /**
   * Check if the user has no files and the list is not loading.
   * @returns True if the list is empty and not loading, false otherwise.
   */
  empty() {
    return !this.hasFiles() && !this.isLoading();
  }
}
flarum.reg.add('fof-upload', 'common/states/FileListState', FileListState);